import * as S from './quantity-badge.styled'
import type { QuantityBadgeProps } from './quantity-badge.types'

export const QuantityBadge = ({
  className,
  color = 'gray',
  quantity,
  size = 'small',
}: QuantityBadgeProps) => {
  return (
    <S.QuantityBadge
      className={className}
      $color={color}
      $size={size}
      data-component-id="QuantityBadge"
    >
      {quantity}
    </S.QuantityBadge>
  )
}
